export const unmaskCurrency = (value: string) => {
  const valueStr = value.replace(/[.,R$ ]/g, '');
  const len = valueStr.length;
  const formatted = `${valueStr.substring(0, len - 2)}.${valueStr.substring(
    len - 2,
  )}`;

  return Number(formatted);
};
